/*
  ============================================================
  loja.js — Interacoes da loja (vanilla JS, sem dependencias)
  ============================================================

  O QUE FAZ:
  - Header: painel de menu mobile, modal de pesquisa e sugestoes
    (Predictive Search API: /search/suggest.json).
  - Cards: chip "n viendo" (numero estavel por produto, com pequena
    variacao), favoritos (localStorage) e "vistos recentemente".
  - Contagem decrescente (ate a meia-noite ou data), carrosseis com
    setas, acordeoes.
  - Modal "adicionado ao carrinho" e barra de envio gratis
    (eventos 'cart:added' / 'cart:updated' de carrinho.js).
  - Pagina de produto: quantidade, barra fixa mobile, data estimada
    de entrega, prova social rotativa.

  OBSERVACOES:
  Tudo e melhoria progressiva: sem JS a loja continua funcional.
  Chaves localStorage: dh_favs, dh_recent, dh_fsb_closed (session).
*/
(function () {
  var strings = window.themeStrings || {};
  var money =
    window.formatMoney ||
    function (c) {
      return (c / 100).toFixed(2);
    };

  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }
  function $$(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }
  function hash(str) {
    var h = 0;
    str = String(str);
    for (var i = 0; i < str.length; i++) {
      h = (h << 5) - h + str.charCodeAt(i);
      h |= 0;
    }
    return Math.abs(h);
  }
  function store(key, fallback) {
    try {
      var v = localStorage.getItem(key);
      return v ? JSON.parse(v) : fallback;
    } catch (e) {
      return fallback;
    }
  }
  function save(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }
  function lockBody(lock) {
    document.body.classList.toggle('is-locked', !!lock);
  }

  /* ---------- Movimento: overlays com transicao de entrada/saida (movimento.css) ---------- */
  var OVERLAY_PANEL = '.drawer__panel, .search-modal__panel, .cmodal__panel, .codm__panel, .col__side-panel';
  function transitionMs(el) {
    var max = 0;
    (getComputedStyle(el).transitionDuration || '').split(',').forEach(function (v) {
      v = v.trim();
      var n = parseFloat(v) || 0;
      if (!/ms$/.test(v)) n *= 1000;
      if (n > max) max = n;
    });
    return max;
  }
  /* mostra o overlay (hidden=false ou classe de display) e, depois do reflow, poe .is-open: a transicao corre */
  function showAnimated(el, displayClass) {
    if (el.__hideCancel) el.__hideCancel(); /* um fecho pendente (listener + timer) nunca pode esconder o que acabou de abrir */
    el.classList.remove('is-closing');
    if (displayClass) el.classList.add(displayClass);
    else el.hidden = false;
    el.getBoundingClientRect();
    el.classList.add('is-open');
  }
  /* tira .is-open, poe .is-closing (saida mais curta) e so esconde no fim da transicao; duracao 0 = imediato */
  function hideAnimated(el, displayClass, after) {
    var panel = $(OVERLAY_PANEL, el) || el;
    var timer = null;
    if (el.__hideCancel) el.__hideCancel();
    function cancel() {
      clearTimeout(timer);
      panel.removeEventListener('transitionend', onEnd);
      el.__hideCancel = null;
    }
    function finish() {
      cancel();
      el.classList.remove('is-closing');
      if (displayClass) el.classList.remove(displayClass);
      else el.hidden = true;
      if (after) after();
    }
    function onEnd(e) {
      if (e.target === panel) finish();
    }
    el.classList.remove('is-open');
    var ms = transitionMs(panel);
    if (!ms) {
      finish();
      return;
    }
    el.classList.add('is-closing');
    panel.addEventListener('transitionend', onEnd);
    timer = setTimeout(finish, ms + 60);
    el.__hideCancel = cancel;
  }
  function isOpen(el) {
    return !!el && el.classList.contains('is-open');
  }

  /* ---------- Datas de entrega: dias uteis (sem domingos) ---------- */
  function addBusinessDays(from, n) {
    var d = new Date(from);
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) n--;
    }
    return d;
  }
  function formatDay(d) {
    var locale = document.documentElement.lang || 'es';
    try {
      return d.toLocaleDateString(locale, { weekday: 'short', day: 'numeric', month: 'short' });
    } catch (e) {
      return d.toDateString();
    }
  }
  function deliveryRange(cutoffHour) {
    var now = new Date();
    var start = addBusinessDays(now, now.getHours() >= (cutoffHour || 14) ? 2 : 1);
    return formatDay(start) + ' \u2013 ' + formatDay(addBusinessDays(start, 1));
  }

  /* ---------- Ofertas por quantidade (pagina de produto): escolher define a quantidade e a etiqueta do botao ---------- */
  /* A Shopify calcula o desconto, trunca-o aos centimos e so depois subtrai.
     Arredondar o total em vez disto dava um centimo a menos do que o carrinho
     cobra, sempre no sentido errado. Ver Issue #73. */
  function descontoDe(bruto, pct) {
    if (!pct) return 0;
    return Math.floor((bruto * pct) / 100);
  }

  function initOffers() {
    var page = $('[data-product-page]');
    if (!page) return;
    var box = $('[data-offers]', page);
    var form = $('form[data-type="add-to-cart-form"]', page);
    if (!box || !form) return;
    var qty = $('[name="quantity"]', form);
    var addLabel = $('[data-add-label]', form);
    var addBtn = $('[data-main-cta]', form);
    var template = box.getAttribute('data-label') || '[qty] \u2013 [total]';
    var threshold = parseInt(box.getAttribute('data-free-threshold') || '0', 10);
    var price = parseInt(box.getAttribute('data-price') || '0', 10);
    var compare = parseInt(box.getAttribute('data-compare') || '0', 10);
    var available = !(addBtn && addBtn.disabled);
    function setText(card, sel, text) {
      var el = $(sel, card);
      if (el) el.textContent = text;
    }
    function render() {
      $$('[data-offer]', box).forEach(function (card) {
        var n = parseInt(card.getAttribute('data-offer'), 10) || 1;
        var pct = parseFloat(card.getAttribute('data-pct') || '0') || 0;
        var full = price * n;
        var total = full - descontoDe(full, pct);
        var compareTotal = compare > price ? compare * n : 0; /* so risca quando ha preco de comparacao real */
        card.__total = total;
        setText(card, '[data-offer-unit]', money(Math.round(total / n)));
        setText(card, '[data-offer-total]', money(total));
        setText(card, '[data-offer-compare]', compareTotal > total ? money(compareTotal) : '');
        setText(card, '[data-offer-saving]', full > total ? '-' + money(full - total) : '');
        var ship = $('[data-offer-ship]', card);
        if (ship) ship.hidden = !(threshold > 0 && total >= threshold);
      });
      update();
    }
    function update() {
      var checked = $('[data-offer] input:checked', box);
      var card = checked ? checked.closest('[data-offer]') : null;
      $$('[data-offer]', box).forEach(function (c) {
        c.classList.toggle('is-selected', c === card);
      });
      if (!card) return;
      var n = parseInt(card.getAttribute('data-offer'), 10) || 1;
      if (qty) qty.value = n;
      if (addLabel && available) addLabel.textContent = template.replace('[qty]', n).replace('[total]', money(card.__total || price * n));
    }
    $$('[data-offer] input', box).forEach(function (r) {
      r.addEventListener('change', update);
    });
    document.addEventListener('variant:change', function (e) {
      var v = e.detail || {};
      if (typeof v.price !== 'number') return;
      price = v.price;
      compare = v.compare_at_price || 0;
      available = v.available !== false;
      render();
    });
    render();
  }

  /* ---------- Calculo de envio por codigo postal (estimativa com as definicoes do tema) ---------- */
  function initShippingCalc() {
    var box = $('[data-ship-calc]');
    if (!box) return;
    var input = $('[data-postal]', box);
    var btn = $('[data-postal-calc]', box);
    var out = $('[data-postal-result]', box);
    var erro = $('[data-postal-error]', box);
    if (!input || !btn || !out || !erro) return;
    var strings = window.themeStrings || {};
    function escrever(sel, texto) {
      var el = $(sel, box);
      if (el) el.textContent = texto;
    }
    function calc() {
      var cp = (input.value || '').trim();
      if (!/^(0[1-9]|[1-4][0-9]|5[0-2])[0-9]{3}$/.test(cp)) {
        out.hidden = true;
        erro.hidden = false;
        erro.textContent = strings.postalInvalid || 'Codigo postal invalido';
        return;
      }
      erro.hidden = true;
      var hora = parseInt(box.getAttribute('data-cutoff') || '14', 10);
      var aTempo = new Date().getHours() < hora;
      escrever('[data-ship-dispatch]', aTempo ? (strings.shipToday || '').replace('[hour]', hora) : strings.shipTomorrow || '');
      escrever('[data-ship-dates]', deliveryRange(hora));
      escrever('[data-ship-cost]', box.getAttribute('data-cost') || '');
      var limite = parseFloat(box.getAttribute('data-free')) || 0;
      var gratis = $('[data-ship-free]', box);
      if (gratis) {
        gratis.hidden = !(limite > 0);
        if (limite > 0) gratis.textContent = (strings.shipFreeFrom || '').replace('[amount]', limite);
      }
      out.hidden = false;
    }
    btn.addEventListener('click', calc);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        calc();
      }
    });
  }

  /* ---------- Nota do produto: usa as avaliacoes desta pagina quando nao ha app de avaliacoes ---------- */
  function initRatingSync() {
    var box = $('[data-product-rating]');
    var summary = $('[data-reviews-summary]');
    if (!box || !summary) return;
    if (box.getAttribute('data-source') === 'app') return; /* com app instalada mandam os metafields */
    var average = parseFloat(summary.getAttribute('data-average')) || 0;
    var count = parseInt(summary.getAttribute('data-count'), 10) || 0;
    var stars = $('.stars', box);
    if (stars) {
      var filled = Math.round(average);
      $$('svg', stars).forEach(function (svg, i) {
        svg.classList.toggle('is-empty', i + 1 > filled);
      });
      var aria = box.getAttribute('data-aria');
      if (aria) stars.setAttribute('aria-label', aria.replace('[rating]', filled));
    }
    var link = $('[data-reviews-link] span', box);
    var label = $('[data-reviews-link]', box);
    if (link && label && label.getAttribute('data-label')) {
      link.textContent = label.getAttribute('data-label').replace('[count]', count);
    }
    box.setAttribute('data-average', average);
    box.setAttribute('data-count', count);
  }

  /* ---------- "Comprados juntos": produto atual + recomendacoes complementares, com troca e adicionar todos ---------- */
  function initBundle() {
    var box = $('[data-bundle]');
    if (!box) return;
    var row = $('[data-bundle-row]', box);
    var addBtn = $('[data-bundle-add]', box);
    var main = $('[data-bundle-card][data-main]', box);
    if (!row || !addBtn || !main) return;
    var strings = {};
    try {
      strings = JSON.parse(box.getAttribute('data-strings') || '{}');
    } catch (e) {}
    var wanted = parseInt(box.getAttribute('data-count') || '2', 10);
    var tier2 = parseFloat(box.getAttribute('data-tier2') || '0') || 0;
    var tier3 = parseFloat(box.getAttribute('data-tier3') || '0') || 0;
    /* o desconto do carrinho e por numero de artigos: 2 artigos, 3 ou mais */
    function tierFor(n) {
      if (n >= 3) return tier3;
      if (n === 2) return tier2;
      return 0;
    }
    var pool = []; /* candidatos ainda nao mostrados */

    function cardFromItem(item) {
      var card = document.createElement('div');
      card.className = 'bundle__card is-on';
      card.setAttribute('data-bundle-card', '');
      ['variant-id', 'price', 'compare', 'title', 'url'].forEach(function (k) {
        card.setAttribute('data-' + k, item.getAttribute('data-' + k) || '');
      });
      var img = item.getAttribute('data-image');
      card.innerHTML =
        '<span class="bundle__check" aria-hidden="true"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m5 13 4 4L19 7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
        '<label class="bundle__pick"><input type="checkbox" checked data-bundle-input><span class="visually-hidden">' +
        escapeHtml(item.getAttribute('data-title') || '') +
        '</span></label>' +
        (img
          ? '<img class="bundle__img" src="' + escapeHtml(img) + '" alt="" width="88" height="88" loading="lazy" decoding="async">'
          : '<span class="bundle__img"></span>') +
        '<span class="bundle__name">' +
        escapeHtml(item.getAttribute('data-title') || '') +
        '</span><span class="bundle__price">' +
        money(parseInt(item.getAttribute('data-price'), 10) || 0) +
        '</span>' +
        '<button type="button" class="bundle__swap" data-bundle-swap aria-label="' +
        escapeHtml(strings.swap || 'Cambiar') +
        '" title="' +
        escapeHtml(strings.swap || 'Cambiar') +
        '"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 12a9 9 0 0 1 15-6.7L21 8M21 12a9 9 0 0 1-15 6.7L3 16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M21 3v5h-5M3 21v-5h5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
      return card;
    }
    function selected() {
      return $$('[data-bundle-card]', row).filter(function (c) {
        var i = $('[data-bundle-input]', c);
        return i && i.checked;
      });
    }
    function update() {
      $$('[data-bundle-card]', row).forEach(function (c) {
        var i = $('[data-bundle-input]', c);
        c.classList.toggle('is-on', !!(i && i.checked));
      });
      var chosen = selected();
      var full = 0;
      var compare = 0;
      chosen.forEach(function (c) {
        var price = parseInt(c.getAttribute('data-price'), 10) || 0;
        var cmp = parseInt(c.getAttribute('data-compare'), 10) || 0;
        full += price;
        compare += cmp > price ? cmp : price;
      });
      var pct = tierFor(chosen.length);
      var total = full - descontoDe(full, pct);
      var setText = function (sel, text) {
        var el = $(sel, box);
        if (el) el.textContent = text;
      };
      setText('[data-bundle-total]', money(total));
      setText('[data-bundle-compare]', compare > total ? money(compare) : '');
      setText('[data-bundle-off]', pct > 0 && chosen.length > 1 ? '-' + pct + '%' : '');
      setText('[data-bundle-count]', chosen.length === 1 ? strings.one || '1' : (strings.other || '[n]').replace('[n]', chosen.length));
      addBtn.disabled = chosen.length === 0;
    }
    function bind(card) {
      var input = $('[data-bundle-input]', card);
      if (input) input.addEventListener('change', update);
      var swap = $('[data-bundle-swap]', card);
      if (swap)
        swap.addEventListener('click', function (e) {
          e.preventDefault();
          if (!pool.length) return;
          var next = pool.shift();
          pool.push(next);
          var fresh = cardFromItem(next);
          card.replaceWith(fresh);
          bind(fresh);
          update();
        });
    }
    fetch(box.getAttribute('data-url'))
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = $$('[data-bundle-item]', doc).filter(function (li) {
          return li.getAttribute('data-product-id') !== String(window.dhProduct && window.dhProduct.id);
        });
        if (items.length < 1) {
          box.hidden = true;
          return;
        }
        pool = items.slice();
        for (var i = 0; i < wanted && pool.length; i++) {
          var plus = document.createElement('span');
          plus.className = 'bundle__plus';
          plus.setAttribute('aria-hidden', 'true');
          plus.textContent = '+';
          row.appendChild(plus);
          var card = cardFromItem(pool.shift());
          row.appendChild(card);
          bind(card);
        }
        initLazyImages();
        update();
      })
      .catch(function (err) {
        box.hidden = true;
        if (typeof window.dhReport === 'function') window.dhReport(err, { origem: 'bundle' });
      });
    bind(main);
    update();

    addBtn.addEventListener('click', function () {
      var chosen = selected();
      if (!chosen.length) return;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var items = chosen.map(function (c) {
        return { id: parseInt(c.getAttribute('data-variant-id'), 10), quantity: 1 };
      });
      addBtn.setAttribute('aria-busy', 'true');
      dhProgress.start();
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          return r.json().then(function (b) {
            return { ok: r.ok, body: b };
          });
        })
        .then(function (res) {
          if (!res.ok) {
            var msg = (res.body && (res.body.description || res.body.message)) || (window.themeStrings || {}).cartError || 'Error';
            if (typeof window.mostrarAlerta === 'function') window.mostrarAlerta(msg, 'negativo', 5000);
            return;
          }
          var done = function () {
            if (typeof window.refreshCart === 'function') window.refreshCart();
            var first = (res.body && res.body.items && res.body.items[0]) || null;
            if (first) document.dispatchEvent(new CustomEvent('cart:added', { detail: first }));
            else if (typeof window.mostrarAlerta === 'function') window.mostrarAlerta((window.themeStrings || {}).bundleAdded || '', 'positivo');
            if (typeof window.dhTrack === 'function') window.dhTrack('bundle_add', { itens: items.length });
          };
          done();
        })
        .catch(function (err) {
          if (typeof window.dhReport === 'function') window.dhReport(err, { origem: 'bundle add' });
          if (typeof window.mostrarAlerta === 'function') window.mostrarAlerta((window.themeStrings || {}).cartError || 'Error', 'negativo', 3000);
        })
        .finally(function () {
          addBtn.removeAttribute('aria-busy');
          dhProgress.done();
        });
    });
  }

  /* ---------- Carrinho: "Completa tu pedido" (Product Recommendations API, com skeleton) ---------- */
  function initCartRecos() {
    var box = $('[data-cart-recos]');
    if (!box) return;
    var list = $('[data-recos-list]', box);
    var url = box.getAttribute('data-url');
    if (!list || !url) return;
    fetch(url)
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = $$('li', doc).filter(function (li) {
          /* nao repetir o que ja esta no carrinho */
          var id = $('[data-product-card]', li) || $('[data-product-id]', li);
          var pid = id ? id.getAttribute('data-product-id') : null;
          return !pid || !$('[data-cart-page] [data-line][data-product-id="' + pid + '"]'); /* o id esta no proprio <article data-line> */
        });
        if (!items.length) {
          box.hidden = true;
          return;
        }
        list.innerHTML = '';
        items.forEach(function (li) {
          list.appendChild(li);
        });
        list.classList.add('grid-enter');
        setTimeout(function () {
          list.classList.remove('grid-enter');
        }, 600);
        initFavorites();
        initViewers();
        initLazyImages();
        initScrollers();
      })
      .catch(function (err) {
        box.hidden = true;
        if (typeof window.dhReport === 'function') window.dhReport(err, { origem: 'cart-recos' });
      });
  }

  /* ---------- Barra de progresso: navegacao entre paginas e pedidos do tema ---------- */
  var dhProgress = (function () {
    var el = null;
    var doneTimer = null;
    function ensure() {
      if (el) return el;
      el = document.createElement('div');
      el.className = 'dh-progress';
      el.setAttribute('aria-hidden', 'true');
      el.hidden = true;
      el.innerHTML = '<span class="dh-progress__bar"></span>';
      document.body.appendChild(el);
      return el;
    }
    return {
      start: function () {
        var p = ensure();
        clearTimeout(doneTimer);
        p.classList.remove('is-done');
        p.hidden = false;
        p.getBoundingClientRect();
        p.classList.add('is-active');
      },
      done: function () {
        if (!el || el.hidden) return;
        el.classList.add('is-done');
        doneTimer = setTimeout(function () {
          el.hidden = true;
          el.classList.remove('is-active');
          el.classList.remove('is-done');
        }, 400);
      }
    };
  })();
  window.dhProgress = dhProgress;
  function initProgress() {
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || a.target === '_blank' || a.hasAttribute('download') || (a.getAttribute('href') || '#').charAt(0) === '#') return;
      var url;
      try {
        url = new URL(a.href, location.href);
      } catch (err) {
        return;
      }
      if (url.origin !== location.origin) return;
      dhProgress.start();
    });
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || e.defaultPrevented || !f.matches || f.matches('form[action$="/cart/add"], form[data-type="add-to-cart-form"], [data-search-form]')) return;
      dhProgress.start();
    });
    window.addEventListener('pageshow', function () {
      dhProgress.done();
    });
  }

  /* ---------- Imagens lazy: aparecem a desvanecer em vez de "saltar"; sem JS ficam visiveis ---------- */
  function initLazyImages() {
    $$('img[loading="lazy"]').forEach(function (img) {
      if (img.__lazyBound || img.complete) return;
      img.__lazyBound = true;
      img.classList.add('is-loading');
      function done() {
        img.classList.remove('is-loading');
        img.classList.add('is-loaded');
      }
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    });
  }

  /* ---------- Seccoes abaixo da dobra revelam-se uma vez (grupo inteiro, sem stagger; o primeiro ecra nunca fica escondido) ---------- */
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('is-visible');
          io.unobserve(en.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px' }
    );
    $$('main .shopify-section').forEach(function (sec) {
      if (sec.__revealBound) return;
      sec.__revealBound = true;
      if (sec.getBoundingClientRect().top < window.innerHeight) return;
      sec.classList.add('reveal');
      io.observe(sec);
    });
  }

  /* ---------- Menu mobile ---------- */
  function initDrawer() {
    var drawer = $('[data-drawer]');
    if (!drawer) return;
    function open() {
      showAnimated(drawer);
      lockBody(true);
      $$('[data-menu-open]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'true');
      });
    }
    function close() {
      hideAnimated(drawer);
      lockBody(false);
      $$('[data-menu-open]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
    }
    $$('[data-menu-open]').forEach(function (b) {
      b.addEventListener('click', open);
    });
    $$('[data-drawer-close]', drawer).forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen(drawer)) close();
    });
  }

  /* ---------- Pesquisa ---------- */
  function initSearch() {
    var modal = $('[data-search-modal]');
    if (modal) {
      var input = $('[data-search-input]', modal);
      function open() {
        showAnimated(modal);
        lockBody(true);
        setTimeout(function () {
          if (input) input.focus();
        }, 50);
      }
      function close() {
        hideAnimated(modal);
        lockBody(false);
      }
      $$('[data-search-open]').forEach(function (b) {
        b.addEventListener('click', open);
      });
      $$('[data-search-close]', modal).forEach(function (b) {
        b.addEventListener('click', close);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isOpen(modal)) close();
      });
    }

    $$('[data-search-form]').forEach(function (form) {
      var input = $('[data-search-input]', form);
      var box = $('[data-search-results]', form);
      if (!input || !box) return;
      var timer = null;
      var last = '';
      /* Tudo o que vem do produto passa por escapeHtml. Os titulos desta loja
         chegam de um feed de fornecedor, nao sao escritos a mao: um titulo com
         HTML la dentro corria no browser de quem pesquisa. Ver Issue #151. */
      function render(q, products) {
        if (!products.length) {
          box.innerHTML = '<p class="suggest__empty">' + (strings.noResults || 'Sin resultados') + '</p>';
        } else {
          box.innerHTML =
            products
              .map(function (p) {
                var img =
                  p.featured_image && p.featured_image.url
                    ? '<img src="' + escapeHtml(p.featured_image.url) + '&width=88" alt="" loading="lazy" decoding="async">'
                    : '<span style="width:44px;height:44px;border-radius:8px;background:var(--color-muted-bg)"></span>';
                return (
                  '<a class="suggest__item" href="' +
                  escapeHtml(p.url) +
                  '">' +
                  img +
                  '<span><span class="suggest__title">' +
                  escapeHtml(p.title) +
                  '</span><br><span class="suggest__price">' +
                  escapeHtml(p.price) +
                  '</span></span></a>'
                );
              })
              .join('') +
            '<a class="suggest__all" href="' +
            escapeHtml(form.getAttribute('action') || '') +
            '?q=' +
            encodeURIComponent(q) +
            '&type=product">' +
            (strings.searchAll || 'Ver todos los resultados') +
            ' &rarr;</a>';
        }
        box.hidden = false;
        initLazyImages();
      }
      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) {
          box.hidden = true;
          box.innerHTML = '';
          last = '';
          return;
        }
        timer = setTimeout(function () {
          if (q === last) return;
          last = q;
          if (!box.querySelector('.suggest__item')) {
            var rows = '';
            for (var i = 0; i < 3; i++) {
              rows +=
                '<div class="skel-row" aria-hidden="true"><span class="skel skel-img"></span><span><span class="skel skel-line"></span><span class="skel skel-line skel-line--short"></span></span></div>';
            }
            box.innerHTML = rows;
            box.hidden = false;
          }
          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          fetch(
            root +
              'search/suggest.json?q=' +
              encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=hide'
          )
            .then(function (r) {
              return r.json();
            })
            .then(function (data) {
              var products = (data.resources && data.resources.results && data.resources.results.products) || [];
              render(q, products);
            })
            .catch(function () {
              box.hidden = true;
            });
        }, 250);
      });
      document.addEventListener('click', function (e) {
        if (!form.contains(e.target)) box.hidden = true;
      });
      input.addEventListener('focus', function () {
        if (box.innerHTML) box.hidden = false;
      });
    });
  }

  /* ---------- Filtros da colecao (barra lateral) ---------- */
  function initFilters() {
    var panel = $('[data-filters-panel]');
    if (!panel) return;
    var isDesktop = function () {
      return window.matchMedia('(min-width: 1024px)').matches;
    };
    function open() {
      showAnimated(panel, 'is-shown');
      if (!isDesktop()) lockBody(true);
      $$('[data-filters-open]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'true');
      });
    }
    function close() {
      hideAnimated(panel, 'is-shown');
      lockBody(false);
      $$('[data-filters-open]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
    }
    $$('[data-filters-open]').forEach(function (b) {
      b.addEventListener('click', open);
    });
    $$('[data-filters-close]', panel).forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) close();
    });

    var form = $('[data-filters]', panel);
    if (!form) return;
    var timer = null;
    function submit() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        dhProgress.start();
        form.submit();
      }, 120);
    }
    $$('input[type="checkbox"]', form).forEach(function (cb) {
      cb.addEventListener('change', submit);
    });
    $$('input[type="number"]', form).forEach(function (inp) {
      inp.addEventListener('change', submit);
      inp.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          submit();
        }
      });
    });
    $$('[data-filter-search]', form).forEach(function (search) {
      var list = search.closest('.fgroup__body');
      if (!list) return;
      search.addEventListener('input', function () {
        var q = search.value.trim().toLowerCase();
        $$('[data-filter-item]', list).forEach(function (li) {
          li.hidden = q !== '' && li.textContent.toLowerCase().indexOf(q) === -1;
        });
      });
    });
  }

  /* ---------- Slider principal ---------- */
  function initSlideshow() {
    $$('[data-slideshow]').forEach(function (root) {
      if (root.__slides) return;
      var slides = $$('[data-slide]', root);
      if (slides.length < 2) return;
      root.__slides = true;
      var dots = $$('[data-slide-to]', root);
      var index = 0,
        timer = null;
      var delay = parseFloat(root.getAttribute('data-autoplay')) || 0; /* milissegundos, aceita meios segundos */
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function go(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) {
          s.classList.toggle('is-active', n === index);
        });
        dots.forEach(function (d, n) {
          d.classList.toggle('is-active', n === index);
        });
      }
      function start() {
        if (delay > 0 && !reduce) {
          stop();
          timer = setInterval(function () {
            go(index + 1);
          }, delay);
        }
      }
      function stop() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          go(parseInt(d.getAttribute('data-slide-to'), 10));
          start();
        });
      });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      /* Arrastar: o mesmo gesto para rato, dedo e caneta, com eventos de ponteiro.
         O slide segue a mao com resistencia para o gesto ter resposta; ao largar,
         passa de slide se andou o suficiente, senao volta ao sitio. */
      var x0 = null,
        y0 = null,
        dx = 0,
        arrastando = false;
      var LIMIAR = 40; /* px a partir dos quais se muda de slide */
      var ARRASTE = 6; /* px a partir dos quais deixa de ser um clique */
      function slideAtual() {
        return slides[index];
      }
      function seguir(valor) {
        var s = slideAtual();
        if (!s) return;
        if (valor === null) {
          s.style.transition = '';
          s.style.transform = '';
        } else {
          s.style.transition = 'none';
          s.style.transform = 'translateX(' + valor * 0.35 + 'px)';
        }
      }
      function largar() {
        if (!arrastando) return;
        arrastando = false;
        root.classList.remove('is-dragging');
        seguir(null);
        if (Math.abs(dx) > LIMIAR) go(dx < 0 ? index + 1 : index - 1);
        start();
      }
      root.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        x0 = e.clientX;
        y0 = e.clientY;
        dx = 0;
        arrastando = true;
        stop();
      });
      root.addEventListener('pointermove', function (e) {
        if (!arrastando) return;
        var ax = e.clientX - x0;
        var ay = e.clientY - y0;
        /* gesto vertical: e a pagina a rolar, nao o carrossel */
        if (Math.abs(ay) > Math.abs(ax) && Math.abs(ay) > 12) {
          arrastando = false;
          seguir(null);
          root.classList.remove('is-dragging');
          start();
          return;
        }
        dx = ax;
        if (Math.abs(dx) > ARRASTE) {
          root.classList.add('is-dragging');
          seguir(dx);
        }
      });
      root.addEventListener('pointerup', largar);
      root.addEventListener('pointercancel', largar);
      root.addEventListener('pointerleave', largar);
      /* Um arrasto que acabe em cima de uma ligacao nao deve abri-la. */
      root.addEventListener(
        'click',
        function (e) {
          if (Math.abs(dx) > ARRASTE) {
            e.preventDefault();
            e.stopPropagation();
            dx = 0;
          }
        },
        true
      );
      root.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });
      go(0);
      start();
    });
  }

  /* ---------- Faixa de oferta: copiar codigo e fechar com memoria ---------- */
  function initPromoBar() {
    $$('[data-promo]').forEach(function (bar) {
      if (bar.__promo) return;
      bar.__promo = true;
      /* Desconto que se aplica sozinho: entra no carrinho na primeira visita e o
         cliente nao escreve codigo nenhum. Corre antes de tudo o resto para
         valer tambem para quem ja fechou a faixa. O limite de um uso por
         cliente e a Shopify que o garante, pelo email, no pagamento. */
      var sozinho = bar.getAttribute('data-promo-auto');
      if (sozinho) {
        var chaveAuto = 'dh:promo:auto:' + sozinho;
        var jaEntrou = false;
        try {
          jaEntrou = !!localStorage.getItem(chaveAuto);
        } catch (e) {}
        if (!jaEntrou) {
          var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          fetch(raiz + 'discount/' + encodeURIComponent(sozinho)).then(
            function () {
              try {
                localStorage.setItem(chaveAuto, String(Date.now()));
              } catch (e) {}
              if (typeof window.dhTrack === 'function') window.dhTrack('promo_auto', { codigo: sozinho });
            },
            function () {}
          );
        }
      }

      var chave = 'dh:promo:' + (bar.getAttribute('data-promo-key') || '');
      var dias = parseFloat(bar.getAttribute('data-promo-days')) || 0;
      /* Fechada ha pouco tempo? Fica fechada. A chave inclui o texto da oferta:
         uma oferta nova volta a aparecer a quem tinha fechado a anterior. */
      var fechada = 0;
      try {
        fechada = parseFloat(localStorage.getItem(chave)) || 0;
      } catch (e) {}
      if (dias > 0 && fechada && Date.now() - fechada < dias * 86400000) {
        bar.parentNode.removeChild(bar);
        return;
      }
      bar.hidden = false;

      var copiar = $('[data-promo-copy]', bar);
      if (copiar) {
        var etiqueta = $('[data-promo-code-label]', copiar);
        var original = etiqueta ? etiqueta.textContent : '';
        var repor = null;
        copiar.addEventListener('click', function () {
          var codigo = copiar.getAttribute('data-promo-copy') || '';
          var strings = window.themeStrings || {};
          function feito() {
            copiar.classList.add('is-copied');
            if (etiqueta) etiqueta.textContent = strings.codeCopied || original;
            if (typeof window.mostrarAlerta === 'function') {
              window.mostrarAlerta((strings.codeCopiedLong || '').replace('[code]', codigo), 'positivo', 3000);
            }
            clearTimeout(repor);
            repor = setTimeout(function () {
              copiar.classList.remove('is-copied');
              if (etiqueta) etiqueta.textContent = original;
            }, 2500);
          }
          if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(codigo).then(feito, feito);
          else feito();
          if (typeof window.dhTrack === 'function') window.dhTrack('promo_code_copy', { codigo: codigo });
        });
      }

      var fechar = $('[data-promo-close]', bar);
      if (fechar) {
        fechar.addEventListener('click', function () {
          try {
            localStorage.setItem(chave, String(Date.now()));
          } catch (e) {}
          bar.style.maxHeight = bar.offsetHeight + 'px';
          /* forca o browser a ler a altura antes de a animar para zero */
          void bar.offsetHeight;
          bar.classList.add('is-closing');
          var terminar = function () {
            if (bar.parentNode) bar.parentNode.removeChild(bar);
          };
          var reduzir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (reduzir) terminar();
          else {
            bar.addEventListener('transitionend', terminar, { once: true });
            setTimeout(terminar, 600);
          }
          if (typeof window.dhTrack === 'function') window.dhTrack('promo_close', {});
        });
      }
    });
  }

  /* ---------- Separadores de produtos ---------- */
  function initTabs() {
    $$('[data-tabs]').forEach(function (root) {
      var tabs = $$('[data-tab]', root);
      var panels = $$('[data-tab-panel]', root);
      if (!tabs.length) return;
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var id = tab.getAttribute('data-tab');
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', String(on));
          });
          panels.forEach(function (p) {
            p.hidden = p.getAttribute('data-tab-panel') !== id;
          });
          initFavorites();
          initFitText();
        });
      });
    });
  }

  /* ---------- Pesquisa do cabecalho: categoria escolhida sem texto -> vai para a categoria ---------- */
  function initHeaderSearch() {
    $$('[data-header-search]').forEach(function (form) {
      var cat = $('[data-search-cat]', form);
      var input = $('[data-search-input]', form);
      if (!cat || !input) return;
      form.addEventListener('submit', function (e) {
        var url = cat.value;
        if (url && input.value.trim() === '') {
          e.preventDefault();
          window.location.href = url;
        }
      });
      cat.addEventListener('change', function () {
        if (cat.value && input.value.trim() === '') window.location.href = cat.value;
      });
    });
  }

  /* ---------- Releasit COD Form: helpers partilhados (produto e carrinho) ---------- */
  function releasitPresent() {
    return !!window._RSI_COD_FORM_SETTINGS || !!document.querySelector('script[src*="releasit"]');
  }
  function waitFor(test, ms) {
    return new Promise(function (resolve) {
      var t0 = Date.now();
      (function tick() {
        var v = test();
        if (v) return resolve(v);
        if (Date.now() - t0 > ms) return resolve(null);
        setTimeout(tick, 120);
      })();
    });
  }
  /* pop-up do tema que recebe o formulario incrustado da app (movido para dentro e devolvido ao fechar) */
  var codModal = { el: null, moved: null, placeholder: null };
  function codModalEnsure() {
    if (codModal.el) return codModal.el;
    var s = window.themeStrings || {};
    var m = document.createElement('div');
    m.className = 'codm';
    m.hidden = true;
    m.innerHTML =
      '<div class="codm__backdrop" data-cod-close></div><div class="codm__panel" role="dialog" aria-modal="true"><button type="button" class="codm__close" data-cod-close aria-label="' +
      (s.close || 'Cerrar') +
      '"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button><div class="codm__body" data-cod-body></div></div>';
    document.body.appendChild(m);
    $$('[data-cod-close]', m).forEach(function (b) {
      b.addEventListener('click', codModalClose);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen(m)) codModalClose();
    });
    codModal.el = m;
    return m;
  }
  function codModalOpen(formEl) {
    var m = codModalEnsure();
    if (codModal.moved && codModal.moved !== formEl) {
      /* outro formulario estava no pop-up: devolve-o ja, sem passar pelo fecho animado */
      if (codModal.placeholder && codModal.placeholder.parentNode) {
        codModal.placeholder.parentNode.insertBefore(codModal.moved, codModal.placeholder);
        codModal.placeholder.remove();
      }
      codModal.moved = null;
      codModal.placeholder = null;
    }
    if (codModal.moved !== formEl) {
      var ph = document.createElement('div');
      ph.hidden = true;
      formEl.parentNode.insertBefore(ph, formEl);
      $('[data-cod-body]', m).appendChild(formEl);
      codModal.moved = formEl;
      codModal.placeholder = ph;
    }
    showAnimated(m);
    lockBody(true);
    if (typeof window.dhTrack === 'function') window.dhTrack('cod_form_open', { pagina: document.body.className });
    var first = formEl.querySelector('input:not([type="hidden"]), select, textarea, button');
    if (first)
      setTimeout(function () {
        try {
          first.focus();
        } catch (e) {}
      }, 60);
  }
  function codModalClose() {
    if (!codModal.el) return;
    lockBody(false);
    hideAnimated(codModal.el, null, function () {
      /* o formulario so volta ao sitio depois da transicao de saida; se o pop-up reabrir entretanto, este passo e cancelado e o formulario fica */
      var moved = codModal.moved;
      var ph = codModal.placeholder;
      codModal.moved = null;
      codModal.placeholder = null;
      if (moved && ph && ph.parentNode) {
        ph.parentNode.insertBefore(moved, ph);
        ph.remove();
      }
    });
  }

  /* ---------- Pagina de produto: "Comprar ahora" abre o formulario do Releasit num pop-up. Checkout so pelo pagamento antecipado dentro do formulario. ---------- */
  function initBuyNow() {
    var page = $('[data-product-page]');
    if (!page) return;
    var btns = $$('[data-buy-now], [data-sticky-buy]');
    if (!btns.length) return;
    var strings = window.themeStrings || {};
    function embeddedForm() {
      return $('#_rsi-form-container-embedded') || $('#rsi_form_wrapper');
    }
    function releasitButton() {
      var list = $$('#rsi_buy_now_button, ._rsi-buy-now-button, .rsi_buy_now_button').filter(function (el) {
        return !el.closest('#cart-wrapper') && !el.closest('#floatingBuyNowButton');
      });
      return list[0] || null;
    }
    function goCheckout(btn) {
      var form = $('form[data-type="add-to-cart-form"]', page);
      if (!form) return;
      var id = $('.product-variant-id', form);
      var qty = $('[name="quantity"]', form);
      if (!id || id.disabled) return;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      dhProgress.start();
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: id.value, quantity: parseInt((qty && qty.value) || '1', 10) || 1 })
      })
        .then(function (r) {
          return r.json().then(function (b) {
            return { ok: r.ok, body: b };
          });
        })
        .then(function (res) {
          if (!res.ok) {
            var msg = (res.body && (res.body.description || res.body.message)) || strings.cartError || 'Error';
            if (typeof window.mostrarAlerta === 'function') window.mostrarAlerta(msg, 'negativo', 5000);
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
            dhProgress.done();
            return;
          }
          window.location.href = root.replace(/\/$/, '') + '/checkout';
        })
        .catch(function (err) {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          dhProgress.done();
          if (typeof window.dhReport === 'function') window.dhReport(err, { origem: 'comprar-ahora cart/add.js' });
          if (typeof window.mostrarAlerta === 'function') window.mostrarAlerta(strings.cartError || 'Error', 'negativo', 3000);
        });
    }
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!releasitPresent()) {
          goCheckout(btn);
          return;
        } /* sem a app: carrinho + checkout */
        btn.classList.add('is-loading');
        waitFor(function () {
          return embeddedForm() || releasitButton();
        }, 5000).then(function () {
          btn.classList.remove('is-loading');
          var emb = embeddedForm();
          if (emb) {
            codModalOpen(emb);
            return;
          } /* modo incrustado: pop-up do tema */
          var rsi = releasitButton();
          if (rsi) {
            rsi.click();
            return;
          } /* modo popup da app */
          if (typeof window.mostrarAlerta === 'function') window.mostrarAlerta(strings.cartError || 'Error', 'negativo', 3000);
        });
      });
    });
    /* links "Leer reseñas" / "Escribir una reseña" abrem o separador certo */
    $$('[data-tab-jump]', page).forEach(function (a) {
      a.addEventListener('click', function () {
        var n = a.getAttribute('data-tab-jump');
        var tab = $('[data-tabs] [data-tab="' + n + '"]', page);
        if (tab) tab.click();
      });
    });
  }

  /* ---------- Carrinho: "Finalizar pedido" abre o formulario do Releasit no pop-up. A app injeta #cart-wrapper antes de .cart__ctas;
     sem ancora (URL com idioma) renderiza o formulario na sua raiz ._rsi-buy-now-button-app-block-hook. Ambos escondidos por CSS. ---------- */
  function initCartCod() {
    var cart = $('[data-cart-page]');
    if (!cart) return;
    var btn = $('button[name="checkout"]', cart);
    if (!btn) return;
    function hasForm(el) {
      return !!(el && el.querySelector('form, input, select, textarea, #rsi_form_wrapper'));
    }
    function codTarget() {
      var wrap = $('#cart-wrapper');
      if (wrap && (hasForm(wrap) || wrap.querySelector('button, a'))) return wrap;
      var anchor = $('#rsi-form-top-anchor');
      if (anchor && hasForm(anchor))
        return anchor.closest('._rsi-buy-now-button-app-block-hook') || anchor; /* mover a raiz inteira mantem os eventos do React */
      return null;
    }
    function fallback() {
      dhProgress.start();
      if (btn.form) btn.form.submit();
      else window.location.href = '/checkout';
    }
    btn.addEventListener('click', function (e) {
      if (!releasitPresent()) return; /* sem a app: checkout normal */
      e.preventDefault();
      btn.classList.add('is-loading');
      waitFor(codTarget, 5000).then(function (target) {
        btn.classList.remove('is-loading');
        if (!target) {
          fallback();
          return;
        }
        if (hasForm(target)) {
          codModalOpen(target);
          return;
        } /* modo incrustado: pop-up do tema */
        var b = target.querySelector('button, a');
        if (b) {
          b.click();
          return;
        } /* modo popup da app */
        fallback();
      });
    });
  }

  /* ---------- Titulos numa so linha ([data-fit-text]) ---------- */
  function initFitText() {
    var els = $$('[data-fit-text]');
    if (!els.length) return;
    els.forEach(function (el) {
      el.style.fontSize = '';
      var size = parseFloat(getComputedStyle(el).fontSize) || 14;
      var min = parseFloat(el.getAttribute('data-fit-min')) || 10;
      var guard = 0;
      while (el.scrollWidth > el.clientWidth && size > min && guard < 40) {
        size -= 0.5;
        el.style.fontSize = size + 'px';
        guard++;
      }
    });
  }

  /* ---------- Chip "n viendo" ---------- */
  function initViewers() {
    var chips = $$('[data-viewers]');
    if (!chips.length) return;
    chips.forEach(function (chip) {
      var card = chip.closest('[data-product-card], [data-product-id]');
      var id = card ? card.getAttribute('data-product-id') || '' : chip.getAttribute('data-id') || '';
      var base = (hash(id || Math.random()) % 15) + 5;
      var span = $('[data-viewers-count]', chip) || chip;
      span.textContent = base;
      chip.__base = base;
    });
    setInterval(function () {
      chips.forEach(function (chip) {
        var span = $('[data-viewers-count]', chip) || chip;
        var current = parseInt(span.textContent, 10) || chip.__base || 5;
        var next = current + (Math.random() > 0.5 ? 1 : -1);
        span.textContent = Math.max(3, Math.min(25, next));
      });
    }, 5000);
  }

  /* ---------- Favoritos ---------- */
  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Painel de favoritos (cabecalho): lista guardada no browser (dh_favs) */
  function renderFavs() {
    var favs = store('dh_favs', []);
    $$('[data-favs-count]').forEach(function (el) {
      el.textContent = favs.length;
    });
    var list = $('[data-favs-list]');
    var empty = $('[data-favs-empty]');
    if (!list) return;
    list.innerHTML = favs
      .map(function (f) {
        var img = f.image ? '<img src="' + escapeHtml(f.image) + '" alt="" loading="lazy" width="64" height="64">' : '<span></span>';
        return (
          '<li class="favs__item">' +
          img +
          '<span><a class="favs__title" href="' +
          escapeHtml(f.url) +
          '">' +
          escapeHtml(f.title) +
          '</a>' +
          (f.price ? '<span class="favs__price">' + escapeHtml(f.price) + '</span>' : '') +
          '</span><button type="button" class="favs__remove" data-fav-remove="' +
          escapeHtml(f.id) +
          '" aria-label="' +
          escapeHtml(strings.removedFavorites || 'Eliminar') +
          '"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button></li>'
        );
      })
      .join('');
    if (empty) empty.hidden = favs.length > 0;
    $$('[data-fav-remove]', list).forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-fav-remove');
        var next = store('dh_favs', []).filter(function (f) {
          return String(f.id) !== String(id);
        });
        save('dh_favs', next);
        $$('[data-fav][data-fav-id="' + id + '"]').forEach(function (btn) {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-pressed', 'false');
        });
        renderFavs();
      });
    });
  }

  function initFavsDrawer() {
    var drawer = $('[data-favs-drawer]');
    renderFavs();
    if (!drawer) return;
    function open() {
      renderFavs();
      showAnimated(drawer);
      lockBody(true);
      $$('[data-favs-open]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'true');
      });
    }
    function close() {
      hideAnimated(drawer);
      lockBody(false);
      $$('[data-favs-open]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
    }
    $$('[data-favs-open]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });
    $$('[data-favs-close]', drawer).forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen(drawer)) close();
    });
  }

  function initFavorites() {
    var favs = store('dh_favs', []);
    function isFav(id) {
      return favs.some(function (f) {
        return String(f.id) === String(id);
      });
    }
    function paint(btn) {
      var active = isFav(btn.getAttribute('data-fav-id'));
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', String(active));
      var label = $('[data-fav-label]', btn);
      if (label) label.textContent = active ? strings.inFavorites || 'En favoritos' : strings.addFavorites || 'Añadir a favoritos';
    }
    $$('[data-fav]').forEach(function (btn) {
      if (btn.__favBound) {
        paint(btn);
        return;
      }
      btn.__favBound = true;
      paint(btn);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        favs = store('dh_favs', []);
        var id = btn.getAttribute('data-fav-id');
        if (isFav(id)) {
          favs = favs.filter(function (f) {
            return String(f.id) !== String(id);
          });
        } else {
          favs.push({
            id: id,
            title: btn.getAttribute('data-fav-title') || '',
            url: btn.getAttribute('data-fav-url') || '',
            image: btn.getAttribute('data-fav-image') || '',
            price: btn.getAttribute('data-fav-price') || ''
          });
        }
        save('dh_favs', favs);
        $$('[data-fav][data-fav-id="' + id + '"]').forEach(paint);
        renderFavs();
        if (typeof window.mostrarAlerta === 'function') {
          window.mostrarAlerta(
            isFav(id) ? strings.addedFavorites || 'Añadido a favoritos' : strings.removedFavorites || 'Eliminado de favoritos',
            'positivo',
            2500
          );
        }
      });
    });
  }

  /* ---------- Vistos recentemente ---------- */
  function initRecentlyViewed() {
    var recent = store('dh_recent', []);
    if (window.dhProduct && window.dhProduct.id) {
      recent = recent.filter(function (p) {
        return String(p.id) !== String(window.dhProduct.id);
      });
      recent.unshift(window.dhProduct);
      recent = recent.slice(0, 10);
      save('dh_recent', recent);
    }
    /* A lista vem do localStorage, escrita a partir dos atributos da ficha:
       o titulo do fornecedor chega aqui na mesma e tem de ser escapado. */
    $$('[data-recently-viewed]').forEach(function (section) {
      var list = $('[data-recently-list]', section);
      var items = recent.filter(function (p) {
        return !window.dhProduct || String(p.id) !== String(window.dhProduct.id);
      });
      if (!list || !items.length) {
        section.hidden = true;
        return;
      }
      list.innerHTML = items
        .map(function (p) {
          var img = p.image ? '<img class="pc__img" src="' + escapeHtml(p.image) + '" alt="" loading="lazy" decoding="async">' : '';
          var old = p.compare ? '<s class="pc__price-old">' + escapeHtml(p.compare) + '</s>' : '';
          return (
            '<article class="pc pc--compact"><div class="pc__media"><a class="pc__media-link" href="' +
            escapeHtml(p.url) +
            '" tabindex="-1" aria-hidden="true">' +
            img +
            '</a></div><div class="pc__body"><div class="pc__price"><span class="pc__price-now">' +
            escapeHtml(p.price) +
            '</span>' +
            old +
            '</div><h3 class="pc__title"><a href="' +
            escapeHtml(p.url) +
            '">' +
            escapeHtml(p.title) +
            '</a></h3></div></article>'
          );
        })
        .join('');
      section.hidden = false;
    });
  }

  /* ---------- Contagem decrescente ---------- */
  function initCountdowns() {
    $$('[data-countdown]').forEach(function (el) {
      var type = el.getAttribute('data-countdown');
      var raw = el.getAttribute('data-end') || '';
      var end;
      if (type === 'midnight' || !raw) {
        end = new Date();
        end.setHours(24, 0, 0, 0);
      } else {
        end = new Date(raw.replace(' ', 'T'));
        if (isNaN(end.getTime())) {
          end = new Date();
          end.setHours(24, 0, 0, 0);
        }
      }
      var h = $('[data-h]', el),
        m = $('[data-m]', el),
        s = $('[data-s]', el),
        d = $('[data-d]', el);
      function pad(n) {
        return (n < 10 ? '0' : '') + n;
      }
      function tick() {
        var diff = Math.max(0, Math.floor((end.getTime() - Date.now()) / 1000));
        if (d) {
          d.textContent = pad(Math.floor(diff / 86400));
          diff = diff % 86400;
        }
        if (h) h.textContent = pad(Math.floor(diff / 3600));
        if (m) m.textContent = pad(Math.floor((diff % 3600) / 60));
        if (s) s.textContent = pad(diff % 60);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Carrosseis ---------- */
  function initScrollers() {
    $$('[data-scroller-wrap]').forEach(function (wrap) {
      var scroller = $('[data-scroller]', wrap);
      if (!scroller || wrap.__scrollerBound) return; /* re-executavel (SRA, recomendacoes) sem duplicar listeners */
      wrap.__scrollerBound = true;

      /* Onde esta a fila: no principio, no fim, ou pelo meio. O CSS usa isto
         para so mostrar a seta que tem para onde levar -- no principio nao ha
         esquerda, no fim nao ha direita. Ver Issue #136. */
      function posicao() {
        var sobra = scroller.scrollWidth - scroller.clientWidth;
        /* A fila tem padding a esquerda, e o encaixe alinha o primeiro cartao
           depois dele: parada no principio, o scrollLeft nao e zero, e o
           proprio padding. Comparar com zero fazia a seta da esquerda aparecer
           logo a entrada, sem haver nada para tras. */
        var margem = (parseFloat(getComputedStyle(scroller).paddingLeft) || 0) + 2;
        wrap.classList.toggle('no-inicio', scroller.scrollLeft <= margem);
        wrap.classList.toggle('no-fim', sobra <= 2 || scroller.scrollLeft >= sobra - 2);
      }
      scroller.addEventListener('scroll', posicao, { passive: true });
      window.addEventListener('resize', posicao);
      /* as imagens ainda podem estar a chegar, e so com elas a fila tem a
         largura final */
      window.addEventListener('load', posicao);
      posicao();
      function move(dir) {
        /* Com data-scroller-page a seta anda uma janela inteira, ou seja,
           exatamente os cartoes que se estao a ver -- tres categorias no
           telemovel. Sem o atributo mantem-se o passo antigo, de dois cartoes,
           que e o dos carrosseis de produtos. */
        if (scroller.hasAttribute('data-scroller-page')) {
          /* o espaco util, sem o padding: a direita ele esta reservado para a
             propria seta, e contar com ele fazia a fila andar a mais */
          var est = getComputedStyle(scroller);
          var util = scroller.clientWidth - (parseFloat(est.paddingLeft) || 0) - (parseFloat(est.paddingRight) || 0);
          scroller.scrollBy({ left: dir * util, behavior: 'smooth' });
          return;
        }
        var first = scroller.firstElementChild;
        var step = first ? first.getBoundingClientRect().width + 16 : scroller.clientWidth * 0.8;
        scroller.scrollBy({ left: dir * step * 2, behavior: 'smooth' });
      }
      $$('[data-scroller-prev]', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          move(-1);
        });
      });
      $$('[data-scroller-next]', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          move(1);
        });
      });

      /* Arrastar com o rato. Com o dedo o proprio browser ja desliza, e mexer
         nisso tiraria a inercia; por isso so o rato entra aqui. */
      var aArrastar = false;
      var arrastou = false;
      var inicioX = 0;
      var inicioScroll = 0;
      scroller.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        aArrastar = true;
        arrastou = false;
        inicioX = e.clientX;
        inicioScroll = scroller.scrollLeft;
      });
      scroller.addEventListener('pointermove', function (e) {
        if (!aArrastar) return;
        var dx = e.clientX - inicioX;
        /* so conta como arrasto depois de alguns pixeis: um clique tremido
           continua a ser um clique */
        if (!arrastou && Math.abs(dx) > 4) {
          arrastou = true;
          scroller.classList.add('is-dragging');
          /* A captura do ponteiro so pode entrar aqui, depois de haver arrasto.
             Capturada no pointerdown, ela muda o alvo do pointerup para o
             carrossel, e o click passa a ser disparado no antepassado comum dos
             dois -- ou seja, no proprio carrossel. O link nunca recebia o
             clique e os cartoes deixavam de abrir. Ver Issue #131. */
          try {
            scroller.setPointerCapture(e.pointerId);
          } catch (err) {}
        }
        if (arrastou) {
          scroller.scrollLeft = inicioScroll - dx;
          e.preventDefault();
        }
      });
      function fimDoArrasto(e) {
        if (!aArrastar) return;
        aArrastar = false;
        scroller.classList.remove('is-dragging');
        try {
          scroller.releasePointerCapture(e.pointerId);
        } catch (err) {}
      }
      scroller.addEventListener('pointerup', fimDoArrasto);
      scroller.addEventListener('pointercancel', fimDoArrasto);
      /* quem arrastou nao quis abrir o produto por baixo do cursor: o clique
         que vem a seguir ao arrasto e cancelado antes de chegar ao link */
      scroller.addEventListener(
        'click',
        function (e) {
          if (!arrastou) return;
          arrastou = false;
          e.preventDefault();
          e.stopPropagation();
        },
        true
      );
      /* Links e imagens sao arrastaveis por omissao e roubavam o gesto: o
         browser comeca um arrasto nativo e cancela os eventos de ponteiro.
         Agora que a captura so entra depois dos quatro pixeis, ha uma janela
         entre carregar e arrastar em que isso pode acontecer, por isso o
         arrasto nativo fica sempre fora: num carrossel nunca serve para nada. */
      scroller.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
    });
  }

  /* ---------- Modal carrinho ---------- */
  function initCartModal() {
    var modal = $('[data-cart-modal]');
    if (!modal) return;
    function close() {
      hideAnimated(modal);
      lockBody(false);
    }
    $$('[data-cart-modal-close]', modal).forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen(modal)) close();
    });
    document.addEventListener('cart:added', function (e) {
      var item = e.detail || {};
      var img = $('[data-cart-modal-image]', modal);
      if (img) {
        if (item.image) {
          img.src = item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x160$1$2');
          img.alt = item.product_title || '';
          img.hidden = false;
        } else {
          img.hidden = true;
        }
      }
      var name = $('[data-cart-modal-name]', modal);
      if (name) name.textContent = item.product_title || item.title || '';
      var price = $('[data-cart-modal-price]', modal);
      if (price) price.textContent = (item.quantity > 1 ? item.quantity + ' x ' : '') + money(item.final_price || item.price || 0);
      showAnimated(modal);
      lockBody(true);
    });
  }

  /* ---------- Barra envio gratis ---------- */
  function initFreeShipping() {
    var bar = $('[data-free-shipping]');
    if (!bar) return;
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 0;
    var closed = false;
    try {
      closed = sessionStorage.getItem('dh_fsb_closed') === '1';
    } catch (e) {}
    if (closed) bar.hidden = true;
    var closeBtn = $('[data-free-shipping-close]', bar);
    if (closeBtn)
      closeBtn.addEventListener('click', function () {
        bar.hidden = true;
        closed = true;
        try {
          sessionStorage.setItem('dh_fsb_closed', '1');
        } catch (e) {}
      });
    document.addEventListener('cart:updated', function (e) {
      var cart = e.detail || {};
      if (closed || document.body.classList.contains('template-cart') || !threshold) return;
      if (!cart.item_count) {
        bar.hidden = true;
        return;
      }
      var missing = threshold - cart.total_price;
      var text = $('[data-free-shipping-text]', bar);
      var fill = $('[data-free-shipping-bar]', bar);
      var icon = $('[data-free-shipping-icon]', bar);
      if (text) {
        text.innerHTML =
          missing <= 0
            ? strings.freeShippingUnlocked || ''
            : (strings.freeShippingMissing || '[amount]').replace('[amount]', '<strong>' + money(missing) + '</strong>');
      }
      if (fill) fill.style.width = Math.min(100, Math.round((cart.total_price / threshold) * 100)) + '%';
      if (icon) icon.classList.toggle('icon-box--success', missing <= 0);
      bar.hidden = false;
    });
  }

  /* ---------- Pagina de produto ---------- */
  function initProductPage() {
    var page = $('[data-product-page]');
    if (!page) return;

    /* quantidade */
    $$('[data-qty]', page).forEach(function (wrap) {
      var input = $('input', wrap);
      $$('[data-qty-minus]', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
          input.dispatchEvent(new Event('change'));
        });
      });
      $$('[data-qty-plus]', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          input.value = (parseInt(input.value, 10) || 1) + 1;
          input.dispatchEvent(new Event('change'));
        });
      });
    });

    /* barra fixa mobile: aparece quando o CTA principal sai do ecra */
    var sticky = $('[data-sticky-bar]');
    var cta = $('[data-main-cta]', page);
    if (sticky && cta && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
        },
        { threshold: 0 }
      ).observe(cta);
      var stickyBtn = $('[data-sticky-add]', sticky);
      if (stickyBtn)
        stickyBtn.addEventListener('click', function () {
          var form = $('form[data-type="add-to-cart-form"]', page);
          if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
        });
    }

    /* datas de entrega estimadas */
    var dateEls = $$('[data-delivery-date]', page);
    if (dateEls.length) {
      var locale = document.documentElement.lang || 'es';
      function addBusinessDays(from, n) {
        var d = new Date(from);
        while (n > 0) {
          d.setDate(d.getDate() + 1);
          if (d.getDay() !== 0) n--;
        }
        return d;
      }
      var fmt = function (d) {
        try {
          return d.toLocaleDateString(locale, { weekday: 'long', day: 'numeric', month: 'long' });
        } catch (e) {
          return d.toDateString();
        }
      };
      var now = new Date();
      var start = addBusinessDays(now, now.getHours() >= 14 ? 2 : 1);
      var endD = addBusinessDays(start, 1);
      dateEls.forEach(function (el) {
        el.textContent = fmt(start) + ' – ' + fmt(endD);
      });
    }

    /* prova social rotativa */
    var proof = $('[data-social-proof]', page);
    if (proof) {
      var items = [];
      try {
        items = JSON.parse(proof.getAttribute('data-items') || '[]');
      } catch (e) {}
      if (items.length) {
        var i = hash(window.dhProduct ? window.dhProduct.id : 'x') % items.length;
        var nameEl = $('[data-proof-name]', proof),
          textEl = $('[data-proof-text]', proof),
          initEl = $('[data-proof-initial]', proof);
        function show() {
          var it = items[i % items.length];
          if (nameEl) nameEl.textContent = it.name;
          if (textEl) textEl.textContent = it.text;
          if (initEl) initEl.textContent = (it.name || '?').charAt(0);
          proof.classList.remove('fade-up');
          void proof.offsetWidth;
          proof.classList.add('fade-up');
          i++;
        }
        show();
        setInterval(show, 7000);
      }
    }

    /* viewers da pagina */
    var pv = $('[data-page-viewers]', page);
    if (pv) {
      var base = (hash(window.dhProduct ? window.dhProduct.id : '1') % 15) + 5;
      pv.textContent = base;
      setInterval(function () {
        var c = parseInt(pv.textContent, 10) || base;
        pv.textContent = Math.max(3, Math.min(25, c + (Math.random() > 0.5 ? 1 : -1)));
      }, 5000);
    }
  }

  /* ---------- Ordenacao best-selling / newest via Section Rendering API ---------- */
  function initSectionRefresh() {
    $$('[data-section-refresh]').forEach(function (root) {
      var url = root.getAttribute('data-section-refresh');
      var min = parseInt(root.getAttribute('data-refresh-min') || '0', 10);
      var total = parseInt(root.getAttribute('data-total') || '0', 10);
      if (!url || total <= min) return;
      var current = $('[data-grid]', root);
      root.setAttribute('aria-busy', 'true');
      if (current) current.classList.add('is-refreshing');
      function settle() {
        root.removeAttribute('aria-busy');
        if (current) current.classList.remove('is-refreshing');
      }
      fetch(url)
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('[data-grid]', doc);
          settle();
          if (fresh && current && fresh.children.length) {
            current.innerHTML = fresh.innerHTML;
            current.classList.add('grid-enter');
            setTimeout(function () {
              current.classList.remove('grid-enter');
            }, 600);
            initViewers();
            initFavorites();
            initLazyImages();
          }
        })
        .catch(function (err) {
          settle();
          if (typeof window.dhReport === 'function') window.dhReport(err, { origem: 'section-refresh', url: url });
        });
    });
  }

  function init() {
    initDrawer();
    initSearch();
    initViewers();
    initFavorites();
    initRecentlyViewed();
    initCountdowns();
    initScrollers();
    initCartModal();
    initFreeShipping();
    initProductPage();
    initOffers();
    initShippingCalc();
    initCartRecos();
    initBundle();
    initRatingSync();
    initSectionRefresh();
    initFilters();
    initSlideshow();
    initPromoBar();
    initTabs();
    initHeaderSearch();
    initFavsDrawer();
    initBuyNow();
    initCartCod();
    initFitText();
    initProgress();
    initLazyImages();
    initReveal();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(initFitText);
    var fitTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(fitTimer);
      fitTimer = setTimeout(initFitText, 150);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () {
    initViewers();
    initFavorites();
    initCountdowns();
    initScrollers();
    initSlideshow();
    initPromoBar();
    initTabs();
    initFitText();
    initLazyImages();
    initReveal();
  });
})();
